import { render, staticRenderFns } from "./modificationDiff.vue?vue&type=template&id=5a8a0d87&scoped=true"
import script from "./modificationDiff.vue?vue&type=script&lang=js"
export * from "./modificationDiff.vue?vue&type=script&lang=js"
import style0 from "./modificationDiff.vue?vue&type=style&index=0&id=5a8a0d87&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a0d87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8a0d87')) {
      api.createRecord('5a8a0d87', component.options)
    } else {
      api.reload('5a8a0d87', component.options)
    }
    module.hot.accept("./modificationDiff.vue?vue&type=template&id=5a8a0d87&scoped=true", function () {
      api.rerender('5a8a0d87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/components/modificationDiff.vue"
export default component.exports